import React from 'react';

type FileIconProps = {
  width?: number;
  height?: number;
};
function FileIcon({ width = 20, height = 20 }: FileIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_19536_36083" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_19536_36083)">
        <path
          d="M7 15H13V13.5H7V15ZM7 12H13V10.5H7V12ZM5.49417 18C5.08139 18 4.72917 17.8531 4.4375 17.5594C4.14583 17.2656 4 16.9125 4 16.5V3.5C4 3.0875 4.14687 2.73438 4.44062 2.44063C4.73437 2.14688 5.0875 2 5.5 2H12L16 6V16.5C16 16.9125 15.8531 17.2656 15.5592 17.5594C15.2653 17.8531 14.9119 18 14.4992 18H5.49417ZM11 7V3.5H5.5V16.5H14.5V7H11Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
}
export default FileIcon;
